var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "focus-trap",
    {
      model: {
        value: _vm.consumModeTrap,
        callback: function callback($$v) {
          _vm.consumModeTrap = $$v
        },
        expression: "consumModeTrap"
      }
    },
    [
      _c("div", [
        _vm.validContext
          ? _c(
              "div",
              {
                staticClass: "cw-structural-element",
                class: {
                  "cw-structural-element-consumemode": _vm.consumeMode
                }
              },
              [
                _vm.structuralElement
                  ? _c(
                      "div",
                      {
                        staticClass: "cw-structural-element-content"
                      },
                      [
                        _c("courseware-ribbon", {
                          attrs: {
                            canEdit: _vm.canEdit && _vm.canAddElements
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "buttons",
                                fn: function fn() {
                                  return [
                                    _vm.prevElement
                                      ? _c(
                                          "router-link",
                                          {
                                            attrs: {
                                              to:
                                                "/structural_element/" +
                                                _vm.prevElement.id
                                            }
                                          },
                                          [
                                            _c("div", {
                                              staticClass:
                                                "cw-ribbon-button cw-ribbon-button-prev",
                                              attrs: {
                                                title: _vm.textRibbon.perv
                                              }
                                            })
                                          ]
                                        )
                                      : _c("div", {
                                          staticClass:
                                            "cw-ribbon-button cw-ribbon-button-prev-disabled",
                                          attrs: {
                                            title: _vm.$gettext(
                                              "Keine vorherige Seite"
                                            )
                                          }
                                        }),
                                    _vm._v(" "),
                                    _vm.nextElement
                                      ? _c(
                                          "router-link",
                                          {
                                            attrs: {
                                              to:
                                                "/structural_element/" +
                                                _vm.nextElement.id
                                            }
                                          },
                                          [
                                            _c("div", {
                                              staticClass:
                                                "cw-ribbon-button cw-ribbon-button-next",
                                              attrs: {
                                                title: _vm.textRibbon.next
                                              }
                                            })
                                          ]
                                        )
                                      : _c("div", {
                                          staticClass:
                                            "cw-ribbon-button cw-ribbon-button-next-disabled",
                                          attrs: {
                                            title: _vm.$gettext(
                                              "Keine nächste Seite"
                                            )
                                          }
                                        })
                                  ]
                                },
                                proxy: true
                              },
                              {
                                key: "breadcrumbList",
                                fn: function fn() {
                                  return [
                                    _vm._l(_vm.ancestors, function(ancestor) {
                                      return _c(
                                        "li",
                                        {
                                          key: ancestor.id,
                                          staticClass:
                                            "cw-ribbon-breadcrumb-item",
                                          attrs: {
                                            title: ancestor.attributes.title
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            [
                                              _c(
                                                "router-link",
                                                {
                                                  attrs: {
                                                    to:
                                                      "/structural_element/" +
                                                      ancestor.id
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      ancestor.attributes
                                                        .title || "–"
                                                    )
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "li",
                                      {
                                        staticClass:
                                          "cw-ribbon-breadcrumb-item cw-ribbon-breadcrumb-item-current",
                                        attrs: {
                                          title:
                                            _vm.structuralElement.attributes
                                              .title
                                        }
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.structuralElement.attributes
                                                .title || "–"
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _vm.isTask
                                          ? _c("span", [
                                              _vm._v(
                                                "[ " +
                                                  _vm._s(_vm.solverName) +
                                                  " ]"
                                              )
                                            ])
                                          : _vm._e()
                                      ]
                                    )
                                  ]
                                },
                                proxy: true
                              },
                              {
                                key: "breadcrumbFallback",
                                fn: function fn() {
                                  return [
                                    _c(
                                      "li",
                                      {
                                        staticClass:
                                          "cw-ribbon-breadcrumb-item cw-ribbon-breadcrumb-item-current",
                                        attrs: {
                                          title:
                                            _vm.structuralElement.attributes
                                              .title
                                        }
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.structuralElement.attributes
                                                .title
                                            )
                                          )
                                        ])
                                      ]
                                    )
                                  ]
                                },
                                proxy: true
                              },
                              {
                                key: "menu",
                                fn: function fn() {
                                  return [
                                    !_vm.consumeMode
                                      ? _c("studip-action-menu", {
                                          staticClass: "cw-ribbon-action-menu",
                                          attrs: {
                                            items: _vm.menuItems,
                                            context:
                                              _vm.structuralElement.attributes
                                                .title
                                          },
                                          on: {
                                            editCurrentElement: function editCurrentElement(
                                              $event
                                            ) {
                                              return _vm.menuAction(
                                                "editCurrentElement"
                                              )
                                            },
                                            addElement: function addElement(
                                              $event
                                            ) {
                                              return _vm.menuAction(
                                                "addElement"
                                              )
                                            },
                                            deleteCurrentElement: function deleteCurrentElement(
                                              $event
                                            ) {
                                              return _vm.menuAction(
                                                "deleteCurrentElement"
                                              )
                                            },
                                            showInfo: function showInfo(
                                              $event
                                            ) {
                                              return _vm.menuAction("showInfo")
                                            },
                                            showExportOptions: function showExportOptions(
                                              $event
                                            ) {
                                              return _vm.menuAction(
                                                "showExportOptions"
                                              )
                                            },
                                            oerCurrentElement: function oerCurrentElement(
                                              $event
                                            ) {
                                              return _vm.menuAction(
                                                "oerCurrentElement"
                                              )
                                            },
                                            setBookmark: function setBookmark(
                                              $event
                                            ) {
                                              return _vm.menuAction(
                                                "setBookmark"
                                              )
                                            },
                                            sortContainers: function sortContainers(
                                              $event
                                            ) {
                                              return _vm.menuAction(
                                                "sortContainers"
                                              )
                                            },
                                            pdfExport: function pdfExport(
                                              $event
                                            ) {
                                              return _vm.menuAction("pdfExport")
                                            },
                                            showSuggest: function showSuggest(
                                              $event
                                            ) {
                                              return _vm.menuAction(
                                                "showSuggest"
                                              )
                                            },
                                            linkElement: function linkElement(
                                              $event
                                            ) {
                                              return _vm.menuAction(
                                                "linkElement"
                                              )
                                            },
                                            removeLock: function removeLock(
                                              $event
                                            ) {
                                              return _vm.menuAction(
                                                "removeLock"
                                              )
                                            }
                                          }
                                        })
                                      : _vm._e()
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            1181400721
                          )
                        }),
                        _vm._v(" "),
                        _vm.canVisit && !_vm.sortMode && !_vm.isLink
                          ? _c(
                              "div",
                              {
                                staticClass: "cw-container-wrapper",
                                class: {
                                  "cw-container-wrapper-consume":
                                    _vm.consumeMode,
                                  "cw-container-wrapper-discuss":
                                    _vm.discussView
                                }
                              },
                              [
                                _vm.structuralElementLoaded
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "cw-companion-box-wrapper"
                                      },
                                      [
                                        _vm.blockedByAnotherUser
                                          ? _c("courseware-companion-box", {
                                              attrs: {
                                                msgCompanion: _vm.$gettextInterpolate(
                                                  _vm.$gettext(
                                                    "Die Einstellungen dieser Seite werden im Moment von %{blockingUserName} bearbeitet"
                                                  ),
                                                  {
                                                    blockingUserName:
                                                      _vm.blockingUserName
                                                  }
                                                ),
                                                mood: "pointing"
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "companionActions",
                                                    fn: function fn() {
                                                      return [
                                                        _vm.userIsTeacher
                                                          ? _c(
                                                              "button",
                                                              {
                                                                staticClass:
                                                                  "button",
                                                                on: {
                                                                  click: function click(
                                                                    $event
                                                                  ) {
                                                                    return _vm.menuAction(
                                                                      "removeLock"
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                                    " +
                                                                    _vm._s(
                                                                      _vm
                                                                        .textRemoveLock
                                                                        .title
                                                                    ) +
                                                                    "\n                                "
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e()
                                                      ]
                                                    },
                                                    proxy: true
                                                  }
                                                ],
                                                null,
                                                false,
                                                1287417919
                                              )
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.showEmptyElementBox
                                          ? _c("courseware-empty-element-box", {
                                              attrs: {
                                                canEdit: _vm.canEdit,
                                                noContainers: _vm.noContainers
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.noContainers &&
                                        _vm.isRoot &&
                                        _vm.canEdit
                                          ? _c("courseware-wellcome-screen")
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.noContainers && _vm.discussView
                                  ? _c(
                                      "courseware-structural-element-discussion",
                                      {
                                        attrs: {
                                          structuralElement:
                                            _vm.structuralElement,
                                          canEdit: _vm.canEdit
                                        }
                                      }
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm._l(_vm.containers, function(container) {
                                  return _c(_vm.containerComponent(container), {
                                    key: container.id,
                                    tag: "component",
                                    staticClass: "cw-container-item",
                                    attrs: {
                                      container: container,
                                      canEdit: _vm.canEdit,
                                      canAddElements: _vm.canAddElements,
                                      isTeacher: _vm.userIsTeacher
                                    }
                                  })
                                })
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isLink
                          ? _c(
                              "div",
                              {
                                staticClass: "cw-container-wrapper",
                                class: {
                                  "cw-container-wrapper-consume":
                                    _vm.consumeMode,
                                  "cw-container-wrapper-discuss":
                                    _vm.discussView
                                }
                              },
                              [
                                _vm.discussView
                                  ? _c(
                                      "courseware-structural-element-discussion",
                                      {
                                        attrs: {
                                          structuralElement:
                                            _vm.structuralElement,
                                          canEdit: _vm.canEdit
                                        }
                                      }
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.editView
                                  ? _c("courseware-companion-box", {
                                      attrs: {
                                        msgCompanion: _vm.$gettextInterpolate(
                                          _vm.$gettext(
                                            "Dieser Inhalt ist aus den persönlichen Lerninhalten von %{ ownerName } verlinkt und kann nur dort bearbeitet werden."
                                          ),
                                          {
                                            ownerName: _vm.ownerName
                                          }
                                        ),
                                        mood: "pointing"
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm._l(_vm.linkedContainers, function(
                                  container
                                ) {
                                  return _c(_vm.containerComponent(container), {
                                    key: container.id,
                                    tag: "component",
                                    staticClass: "cw-container-item",
                                    attrs: {
                                      container: container,
                                      canEdit: false,
                                      canAddElements: false,
                                      isTeacher: _vm.userIsTeacher
                                    }
                                  })
                                })
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.canVisit && _vm.canEdit && _vm.sortMode
                          ? _c(
                              "div",
                              {
                                staticClass: "cw-container-wrapper-sort-mode"
                              },
                              [
                                _c(
                                  "draggable",
                                  _vm._b(
                                    {
                                      staticClass:
                                        "cw-structural-element-list-sort-mode",
                                      attrs: {
                                        tag: "ul",
                                        handle: ".cw-sortable-handle"
                                      },
                                      on: {
                                        start: function start($event) {
                                          _vm.isDragging = true
                                        },
                                        end: function end($event) {
                                          _vm.isDragging = false
                                        }
                                      },
                                      model: {
                                        value: _vm.containerList,
                                        callback: function callback($$v) {
                                          _vm.containerList = $$v
                                        },
                                        expression: "containerList"
                                      }
                                    },
                                    "draggable",
                                    _vm.dragOptions,
                                    false
                                  ),
                                  [
                                    _c(
                                      "transition-group",
                                      {
                                        attrs: {
                                          type: "transition",
                                          name: "flip-containers"
                                        }
                                      },
                                      _vm._l(_vm.containerList, function(
                                        container
                                      ) {
                                        return _c(
                                          "li",
                                          {
                                            key: container.id,
                                            staticClass:
                                              "cw-container-item-sortable"
                                          },
                                          [
                                            _c("span", {
                                              staticClass: "cw-sortable-handle"
                                            }),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  container.attributes.title
                                                ) +
                                                  " (" +
                                                  _vm._s(
                                                    container.attributes.width
                                                  ) +
                                                  ")"
                                              )
                                            ])
                                          ]
                                        )
                                      }),
                                      0
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "cw-container-sort-buttons"
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "button accept",
                                        on: {
                                          click: _vm.storeSort
                                        }
                                      },
                                      [
                                        _c("translate", [
                                          _vm._v("Sortierung speichern")
                                        ])
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass: "button cancel",
                                        on: {
                                          click: _vm.resetSort
                                        }
                                      },
                                      [
                                        _c("translate", [
                                          _vm._v("Sortieren abbrechen")
                                        ])
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.canVisit
                          ? _c(
                              "div",
                              {
                                staticClass: "cw-container-wrapper",
                                class: {
                                  "cw-container-wrapper-consume":
                                    _vm.consumeMode
                                }
                              },
                              [
                                _vm.structuralElementLoaded
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "cw-companion-box-wrapper"
                                      },
                                      [
                                        _c("courseware-companion-box", {
                                          attrs: {
                                            mood: "sad",
                                            msgCompanion: _vm.$gettext(
                                              "Diese Seite steht Ihnen leider nicht zur Verfügung."
                                            )
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showEditDialog
                  ? _c("studip-dialog", {
                      staticClass: "studip-dialog-with-tab",
                      attrs: {
                        title: _vm.textEdit.title,
                        confirmText: _vm.textEdit.confirm,
                        confirmClass: "accept",
                        closeText: _vm.textEdit.close,
                        closeClass: "cancel",
                        height: "500",
                        width: "500"
                      },
                      on: {
                        close: _vm.closeEditDialog,
                        confirm: _vm.storeCurrentElement
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "dialogContent",
                            fn: function fn() {
                              return [
                                _c(
                                  "courseware-tabs",
                                  {
                                    staticClass: "cw-tab-in-dialog"
                                  },
                                  [
                                    _c(
                                      "courseware-tab",
                                      {
                                        attrs: {
                                          name: _vm.textEdit.basic,
                                          selected: true,
                                          index: 0
                                        }
                                      },
                                      [
                                        _c(
                                          "form",
                                          {
                                            staticClass: "default",
                                            on: {
                                              submit: function submit($event) {
                                                $event.preventDefault()
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "label",
                                              [
                                                _c("translate", [
                                                  _vm._v("Titel")
                                                ]),
                                                _vm._v(" "),
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.currentElement
                                                          .attributes.title,
                                                      expression:
                                                        "currentElement.attributes.title"
                                                    }
                                                  ],
                                                  attrs: {
                                                    type: "text"
                                                  },
                                                  domProps: {
                                                    value:
                                                      _vm.currentElement
                                                        .attributes.title
                                                  },
                                                  on: {
                                                    input: function input(
                                                      $event
                                                    ) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }

                                                      _vm.$set(
                                                        _vm.currentElement
                                                          .attributes,
                                                        "title",
                                                        $event.target.value
                                                      )
                                                    }
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "label",
                                              [
                                                _c("translate", [
                                                  _vm._v("Beschreibung")
                                                ]),
                                                _vm._v(" "),
                                                _c("textarea", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.currentElement
                                                          .attributes.payload
                                                          .description,
                                                      expression:
                                                        "currentElement.attributes.payload.description"
                                                    }
                                                  ],
                                                  staticClass:
                                                    "cw-structural-element-description",
                                                  domProps: {
                                                    value:
                                                      _vm.currentElement
                                                        .attributes.payload
                                                        .description
                                                  },
                                                  on: {
                                                    input: function input(
                                                      $event
                                                    ) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }

                                                      _vm.$set(
                                                        _vm.currentElement
                                                          .attributes.payload,
                                                        "description",
                                                        $event.target.value
                                                      )
                                                    }
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "courseware-tab",
                                      {
                                        attrs: {
                                          name: _vm.textEdit.meta,
                                          index: 1
                                        }
                                      },
                                      [
                                        _c(
                                          "form",
                                          {
                                            staticClass: "default",
                                            on: {
                                              submit: function submit($event) {
                                                $event.preventDefault()
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "label",
                                              [
                                                _c("translate", [
                                                  _vm._v("Farbe")
                                                ]),
                                                _vm._v(" "),
                                                _c("studip-select", {
                                                  staticClass: "cw-vs-select",
                                                  attrs: {
                                                    options: _vm.colors,
                                                    reduce: function reduce(
                                                      color
                                                    ) {
                                                      return color.class
                                                    },
                                                    label: "class"
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "open-indicator",
                                                        fn: function fn(
                                                          selectAttributes
                                                        ) {
                                                          return [
                                                            _c(
                                                              "span",
                                                              _vm._b(
                                                                {},
                                                                "span",
                                                                selectAttributes,
                                                                false
                                                              ),
                                                              [
                                                                _c(
                                                                  "studip-icon",
                                                                  {
                                                                    attrs: {
                                                                      shape:
                                                                        "arr_1down",
                                                                      size: "10"
                                                                    }
                                                                  }
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                        }
                                                      },
                                                      {
                                                        key: "no-options",
                                                        fn: function fn(_ref) {
                                                          var search =
                                                              _ref.search,
                                                            searching =
                                                              _ref.searching,
                                                            loading =
                                                              _ref.loading
                                                          return [
                                                            _c("translate", [
                                                              _vm._v(
                                                                "Es steht keine Auswahl zur Verfügung"
                                                              )
                                                            ]),
                                                            _vm._v(
                                                              ".\n                                        "
                                                            )
                                                          ]
                                                        }
                                                      },
                                                      {
                                                        key: "selected-option",
                                                        fn: function fn(_ref2) {
                                                          var name = _ref2.name,
                                                            hex = _ref2.hex
                                                          return [
                                                            _c("span", {
                                                              staticClass:
                                                                "vs__option-color",
                                                              style: {
                                                                "background-color": hex
                                                              }
                                                            }),
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(name)
                                                              )
                                                            ])
                                                          ]
                                                        }
                                                      },
                                                      {
                                                        key: "option",
                                                        fn: function fn(_ref3) {
                                                          var name = _ref3.name,
                                                            hex = _ref3.hex
                                                          return [
                                                            _c("span", {
                                                              staticClass:
                                                                "vs__option-color",
                                                              style: {
                                                                "background-color": hex
                                                              }
                                                            }),
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(name)
                                                              )
                                                            ])
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    false,
                                                    2110802609
                                                  ),
                                                  model: {
                                                    value:
                                                      _vm.currentElement
                                                        .attributes.payload
                                                        .color,
                                                    callback: function callback(
                                                      $$v
                                                    ) {
                                                      _vm.$set(
                                                        _vm.currentElement
                                                          .attributes.payload,
                                                        "color",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "currentElement.attributes.payload.color"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "label",
                                              [
                                                _c("translate", [
                                                  _vm._v(
                                                    "Art des Lernmaterials"
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "select",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.currentElement
                                                            .attributes.purpose,
                                                        expression:
                                                          "currentElement.attributes.purpose"
                                                      }
                                                    ],
                                                    on: {
                                                      change: function change(
                                                        $event
                                                      ) {
                                                        var $$selectedVal = Array.prototype.filter
                                                          .call(
                                                            $event.target
                                                              .options,
                                                            function(o) {
                                                              return o.selected
                                                            }
                                                          )
                                                          .map(function(o) {
                                                            var val =
                                                              "_value" in o
                                                                ? o._value
                                                                : o.value
                                                            return val
                                                          })

                                                        _vm.$set(
                                                          _vm.currentElement
                                                            .attributes,
                                                          "purpose",
                                                          $event.target.multiple
                                                            ? $$selectedVal
                                                            : $$selectedVal[0]
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "option",
                                                      {
                                                        attrs: {
                                                          value: "content"
                                                        }
                                                      },
                                                      [
                                                        _c("translate", [
                                                          _vm._v("Inhalt")
                                                        ])
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    !_vm.inCourse
                                                      ? _c(
                                                          "option",
                                                          {
                                                            attrs: {
                                                              value: "template"
                                                            }
                                                          },
                                                          [
                                                            _c("translate", [
                                                              _vm._v(
                                                                "Aufgabenvorlage"
                                                              )
                                                            ])
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c(
                                                      "option",
                                                      {
                                                        attrs: {
                                                          value: "oer"
                                                        }
                                                      },
                                                      [
                                                        _c("translate", [
                                                          _vm._v("OER-Material")
                                                        ])
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "option",
                                                      {
                                                        attrs: {
                                                          value: "portfolio"
                                                        }
                                                      },
                                                      [
                                                        _c("translate", [
                                                          _vm._v("ePortfolio")
                                                        ])
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "option",
                                                      {
                                                        attrs: {
                                                          value: "draft"
                                                        }
                                                      },
                                                      [
                                                        _c("translate", [
                                                          _vm._v("Entwurf")
                                                        ])
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "option",
                                                      {
                                                        attrs: {
                                                          value: "other"
                                                        }
                                                      },
                                                      [
                                                        _c("translate", [
                                                          _vm._v("Sonstiges")
                                                        ])
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "label",
                                              [
                                                _c("translate", [
                                                  _vm._v("Lizenztyp")
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "select",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.currentElement
                                                            .attributes.payload
                                                            .license_type,
                                                        expression:
                                                          "currentElement.attributes.payload.license_type"
                                                      }
                                                    ],
                                                    on: {
                                                      change: function change(
                                                        $event
                                                      ) {
                                                        var $$selectedVal = Array.prototype.filter
                                                          .call(
                                                            $event.target
                                                              .options,
                                                            function(o) {
                                                              return o.selected
                                                            }
                                                          )
                                                          .map(function(o) {
                                                            var val =
                                                              "_value" in o
                                                                ? o._value
                                                                : o.value
                                                            return val
                                                          })

                                                        _vm.$set(
                                                          _vm.currentElement
                                                            .attributes.payload,
                                                          "license_type",
                                                          $event.target.multiple
                                                            ? $$selectedVal
                                                            : $$selectedVal[0]
                                                        )
                                                      }
                                                    }
                                                  },
                                                  _vm._l(_vm.licenses, function(
                                                    license
                                                  ) {
                                                    return _c(
                                                      "option",
                                                      {
                                                        key: license.id,
                                                        domProps: {
                                                          value: license.id
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                            " +
                                                            _vm._s(
                                                              license.name
                                                            ) +
                                                            "\n                                        "
                                                        )
                                                      ]
                                                    )
                                                  }),
                                                  0
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "label",
                                              [
                                                _c("translate", [
                                                  _vm._v(
                                                    "Geschätzter zeitlicher Aufwand"
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.currentElement
                                                          .attributes.payload
                                                          .required_time,
                                                      expression:
                                                        "currentElement.attributes.payload.required_time"
                                                    }
                                                  ],
                                                  attrs: {
                                                    type: "text"
                                                  },
                                                  domProps: {
                                                    value:
                                                      _vm.currentElement
                                                        .attributes.payload
                                                        .required_time
                                                  },
                                                  on: {
                                                    input: function input(
                                                      $event
                                                    ) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }

                                                      _vm.$set(
                                                        _vm.currentElement
                                                          .attributes.payload,
                                                        "required_time",
                                                        $event.target.value
                                                      )
                                                    }
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "label",
                                              [
                                                _c("translate", [
                                                  _vm._v("Niveau")
                                                ]),
                                                _c("br"),
                                                _vm._v(" "),
                                                _c("translate", [
                                                  _vm._v("von")
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "select",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.currentElement
                                                            .attributes.payload
                                                            .difficulty_start,
                                                        expression:
                                                          "currentElement.attributes.payload.difficulty_start"
                                                      }
                                                    ],
                                                    on: {
                                                      change: function change(
                                                        $event
                                                      ) {
                                                        var $$selectedVal = Array.prototype.filter
                                                          .call(
                                                            $event.target
                                                              .options,
                                                            function(o) {
                                                              return o.selected
                                                            }
                                                          )
                                                          .map(function(o) {
                                                            var val =
                                                              "_value" in o
                                                                ? o._value
                                                                : o.value
                                                            return val
                                                          })

                                                        _vm.$set(
                                                          _vm.currentElement
                                                            .attributes.payload,
                                                          "difficulty_start",
                                                          $event.target.multiple
                                                            ? $$selectedVal
                                                            : $$selectedVal[0]
                                                        )
                                                      }
                                                    }
                                                  },
                                                  _vm._l(12, function(
                                                    difficulty_start
                                                  ) {
                                                    return _c(
                                                      "option",
                                                      {
                                                        key: difficulty_start,
                                                        domProps: {
                                                          value: difficulty_start
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                            " +
                                                            _vm._s(
                                                              difficulty_start
                                                            ) +
                                                            "\n                                        "
                                                        )
                                                      ]
                                                    )
                                                  }),
                                                  0
                                                ),
                                                _vm._v(" "),
                                                _c("translate", [
                                                  _vm._v("bis")
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "select",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.currentElement
                                                            .attributes.payload
                                                            .difficulty_end,
                                                        expression:
                                                          "currentElement.attributes.payload.difficulty_end"
                                                      }
                                                    ],
                                                    on: {
                                                      change: function change(
                                                        $event
                                                      ) {
                                                        var $$selectedVal = Array.prototype.filter
                                                          .call(
                                                            $event.target
                                                              .options,
                                                            function(o) {
                                                              return o.selected
                                                            }
                                                          )
                                                          .map(function(o) {
                                                            var val =
                                                              "_value" in o
                                                                ? o._value
                                                                : o.value
                                                            return val
                                                          })

                                                        _vm.$set(
                                                          _vm.currentElement
                                                            .attributes.payload,
                                                          "difficulty_end",
                                                          $event.target.multiple
                                                            ? $$selectedVal
                                                            : $$selectedVal[0]
                                                        )
                                                      }
                                                    }
                                                  },
                                                  _vm._l(12, function(
                                                    difficulty_end
                                                  ) {
                                                    return _c(
                                                      "option",
                                                      {
                                                        key: difficulty_end,
                                                        domProps: {
                                                          value: difficulty_end
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                            " +
                                                            _vm._s(
                                                              difficulty_end
                                                            ) +
                                                            "\n                                        "
                                                        )
                                                      ]
                                                    )
                                                  }),
                                                  0
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "courseware-tab",
                                      {
                                        attrs: {
                                          name: _vm.textEdit.image,
                                          index: 2
                                        }
                                      },
                                      [
                                        _c(
                                          "form",
                                          {
                                            staticClass: "default",
                                            on: {
                                              submit: function submit($event) {
                                                $event.preventDefault()
                                              }
                                            }
                                          },
                                          [
                                            _vm.showPreviewImage
                                              ? _c("img", {
                                                  staticClass:
                                                    "cw-structural-element-image-preview",
                                                  attrs: {
                                                    src: _vm.image,
                                                    alt: _vm.$gettext(
                                                      "Vorschaubild"
                                                    )
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.showPreviewImage
                                              ? _c("label", [
                                                  _c(
                                                    "button",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "translate",
                                                          rawName: "v-translate"
                                                        }
                                                      ],
                                                      staticClass: "button",
                                                      on: {
                                                        click: _vm.deleteImage
                                                      }
                                                    },
                                                    [_vm._v("Bild löschen")]
                                                  )
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.uploadFileError
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "messagebox messagebox_error"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                    " +
                                                        _vm._s(
                                                          _vm.uploadFileError
                                                        ) +
                                                        "\n                                "
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            !_vm.showPreviewImage
                                              ? _c(
                                                  "label",
                                                  [
                                                    _c("translate", [
                                                      _vm._v("Bild hochladen")
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("input", {
                                                      ref: "upload_image",
                                                      attrs: {
                                                        type: "file",
                                                        accept: "image/*"
                                                      },
                                                      on: {
                                                        change:
                                                          _vm.checkUploadFile
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "courseware-tab",
                                      {
                                        attrs: {
                                          name: _vm.textEdit.approval,
                                          index: 3
                                        }
                                      },
                                      [
                                        _vm.inCourse
                                          ? _c(
                                              "courseware-structural-element-permissions",
                                              {
                                                attrs: {
                                                  element: _vm.currentElement
                                                },
                                                on: {
                                                  updateReadApproval:
                                                    _vm.updateReadApproval,
                                                  updateWriteApproval:
                                                    _vm.updateWriteApproval
                                                }
                                              }
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.inCourse
                                      ? _c(
                                          "courseware-tab",
                                          {
                                            attrs: {
                                              name: _vm.textEdit.visible,
                                              index: 4
                                            }
                                          },
                                          [
                                            _c(
                                              "form",
                                              {
                                                staticClass: "default",
                                                on: {
                                                  submit: function submit(
                                                    $event
                                                  ) {
                                                    $event.preventDefault()
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "label",
                                                  [
                                                    _c("translate", [
                                                      _vm._v("Sichtbar ab")
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.currentElement
                                                              .attributes[
                                                              "release-date"
                                                            ],
                                                          expression:
                                                            "currentElement.attributes['release-date']"
                                                        }
                                                      ],
                                                      attrs: {
                                                        type: "date"
                                                      },
                                                      domProps: {
                                                        value:
                                                          _vm.currentElement
                                                            .attributes[
                                                            "release-date"
                                                          ]
                                                      },
                                                      on: {
                                                        input: function input(
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }

                                                          _vm.$set(
                                                            _vm.currentElement
                                                              .attributes,
                                                            "release-date",
                                                            $event.target.value
                                                          )
                                                        }
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  [
                                                    _c("translate", [
                                                      _vm._v("Unsichtbar ab")
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.currentElement
                                                              .attributes[
                                                              "withdraw-date"
                                                            ],
                                                          expression:
                                                            "currentElement.attributes['withdraw-date']"
                                                        }
                                                      ],
                                                      attrs: {
                                                        type: "date"
                                                      },
                                                      domProps: {
                                                        value:
                                                          _vm.currentElement
                                                            .attributes[
                                                            "withdraw-date"
                                                          ]
                                                      },
                                                      on: {
                                                        input: function input(
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }

                                                          _vm.$set(
                                                            _vm.currentElement
                                                              .attributes,
                                                            "withdraw-date",
                                                            $event.target.value
                                                          )
                                                        }
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        3920845294
                      )
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.showAddDialog
                  ? _c("studip-dialog", {
                      staticClass: "cw-structural-element-dialog",
                      attrs: {
                        title: _vm.$gettext("Seite hinzufügen"),
                        confirmText: _vm.$gettext("Erstellen"),
                        confirmClass: "accept",
                        closeText: _vm.$gettext("Schließen"),
                        closeClass: "cancel"
                      },
                      on: {
                        close: _vm.closeAddDialog,
                        confirm: _vm.createElement
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "dialogContent",
                            fn: function fn() {
                              return [
                                _c(
                                  "form",
                                  {
                                    staticClass: "default",
                                    on: {
                                      submit: function submit($event) {
                                        $event.preventDefault()
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "label",
                                      [
                                        _c("translate", [
                                          _vm._v("Position der neuen Seite")
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.newChapterParent,
                                                expression: "newChapterParent"
                                              }
                                            ],
                                            on: {
                                              change: function change($event) {
                                                var $$selectedVal = Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function(o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function(o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                                _vm.newChapterParent = $event
                                                  .target.multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              }
                                            }
                                          },
                                          [
                                            !_vm.isRoot && _vm.canEditParent
                                              ? _c(
                                                  "option",
                                                  {
                                                    attrs: {
                                                      value: "sibling"
                                                    }
                                                  },
                                                  [
                                                    _c("translate", [
                                                      _vm._v(
                                                        "Neben der aktuellen Seite"
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "option",
                                              {
                                                attrs: {
                                                  value: "descendant"
                                                }
                                              },
                                              [
                                                _c("translate", [
                                                  _vm._v(
                                                    "Unterhalb der aktuellen Seite"
                                                  )
                                                ])
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      [
                                        _c("translate", [
                                          _vm._v("Name der neuen Seite")
                                        ]),
                                        _c("br"),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.newChapterName,
                                              expression: "newChapterName"
                                            }
                                          ],
                                          attrs: {
                                            type: "text"
                                          },
                                          domProps: {
                                            value: _vm.newChapterName
                                          },
                                          on: {
                                            input: function input($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.newChapterName =
                                                $event.target.value
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        2704705767
                      )
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.showInfoDialog
                  ? _c("studip-dialog", {
                      attrs: {
                        title: _vm.textInfo.title,
                        closeText: _vm.textInfo.close,
                        closeClass: "cancel"
                      },
                      on: {
                        close: function close($event) {
                          return _vm.showElementInfoDialog(false)
                        }
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "dialogContent",
                            fn: function fn() {
                              return [
                                _c(
                                  "table",
                                  {
                                    staticClass: "cw-structural-element-info"
                                  },
                                  [
                                    _c("tr", [
                                      _c(
                                        "td",
                                        [
                                          _c("translate", [_vm._v("Titel")]),
                                          _vm._v(":")
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.structuralElement.attributes
                                              .title
                                          )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c(
                                        "td",
                                        [
                                          _c("translate", [
                                            _vm._v("Beschreibung")
                                          ]),
                                          _vm._v(":")
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.structuralElement.attributes
                                              .payload.description
                                          )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c(
                                        "td",
                                        [
                                          _c("translate", [
                                            _vm._v("Seite wurde erstellt von")
                                          ]),
                                          _vm._v(":")
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("td", [_vm._v(_vm._s(_vm.ownerName))])
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c(
                                        "td",
                                        [
                                          _c("translate", [
                                            _vm._v("Seite wurde erstellt am")
                                          ]),
                                          _vm._v(":")
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        [
                                          _c("iso-date", {
                                            attrs: {
                                              date:
                                                _vm.structuralElement.attributes
                                                  .mkdate
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c(
                                        "td",
                                        [
                                          _c("translate", [
                                            _vm._v("Zuletzt bearbeitet von")
                                          ]),
                                          _vm._v(":")
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("td", [_vm._v(_vm._s(_vm.editorName))])
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c(
                                        "td",
                                        [
                                          _c("translate", [
                                            _vm._v("Zuletzt bearbeitet am")
                                          ]),
                                          _vm._v(":")
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        [
                                          _c("iso-date", {
                                            attrs: {
                                              date:
                                                _vm.structuralElement.attributes
                                                  .chdate
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ])
                                  ]
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        4136533683
                      )
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.showExportDialog
                  ? _c("studip-dialog", {
                      attrs: {
                        title: _vm.textExport.title,
                        confirmText: _vm.textExport.confirm,
                        confirmClass: "accept",
                        closeText: _vm.textExport.close,
                        closeClass: "cancel",
                        height: "350"
                      },
                      on: {
                        close: function close($event) {
                          return _vm.showElementExportDialog(false)
                        },
                        confirm: _vm.exportCurrentElement
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "dialogContent",
                            fn: function fn() {
                              return [
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !_vm.exportRunning,
                                        expression: "!exportRunning"
                                      }
                                    ]
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "translate",
                                            rawName: "v-translate"
                                          }
                                        ]
                                      },
                                      [
                                        _vm._v(
                                          'Hiermit exportieren Sie die Seite "%{ currentElement.attributes.title }" als ZIP-Datei.'
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "cw-element-export"
                                      },
                                      [
                                        _c(
                                          "label",
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.exportChildren,
                                                  expression: "exportChildren"
                                                }
                                              ],
                                              attrs: {
                                                type: "checkbox"
                                              },
                                              domProps: {
                                                checked: Array.isArray(
                                                  _vm.exportChildren
                                                )
                                                  ? _vm._i(
                                                      _vm.exportChildren,
                                                      null
                                                    ) > -1
                                                  : _vm.exportChildren
                                              },
                                              on: {
                                                change: function change(
                                                  $event
                                                ) {
                                                  var $$a = _vm.exportChildren,
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false

                                                  if (Array.isArray($$a)) {
                                                    var $$v = null,
                                                      $$i = _vm._i($$a, $$v)

                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        (_vm.exportChildren = $$a.concat(
                                                          [$$v]
                                                        ))
                                                    } else {
                                                      $$i > -1 &&
                                                        (_vm.exportChildren = $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          ))
                                                    }
                                                  } else {
                                                    _vm.exportChildren = $$c
                                                  }
                                                }
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("translate", [
                                              _vm._v("Unterseiten exportieren")
                                            ])
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("courseware-companion-box", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.exportRunning,
                                      expression: "exportRunning"
                                    }
                                  ],
                                  attrs: {
                                    msgCompanion: _vm.$gettext(
                                      "Export läuft, bitte haben sie einen Moment Geduld..."
                                    ),
                                    mood: "pointing"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.exportRunning,
                                        expression: "exportRunning"
                                      }
                                    ],
                                    staticClass: "cw-import-zip"
                                  },
                                  [
                                    _c("header", [
                                      _vm._v(_vm._s(_vm.exportState) + ":")
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "progress-bar-wrapper"
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "progress-bar",
                                            style: {
                                              width: _vm.exportProgress + "%"
                                            },
                                            attrs: {
                                              role: "progressbar",
                                              "aria-valuenow":
                                                _vm.exportProgress,
                                              "aria-valuemin": "0",
                                              "aria-valuemax": "100"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(_vm.exportProgress) +
                                                "%\n                            "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        2894709203
                      )
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.showPdfExportDialog
                  ? _c("studip-dialog", {
                      attrs: {
                        title: _vm.textExport.title,
                        confirmText: _vm.textExport.confirm,
                        confirmClass: "accept",
                        closeText: _vm.textExport.close,
                        closeClass: "cancel",
                        height: "350"
                      },
                      on: {
                        close: function close($event) {
                          return _vm.showElementPdfExportDialog(false)
                        },
                        confirm: _vm.pdfExportCurrentElement
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "dialogContent",
                            fn: function fn() {
                              return [
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "translate",
                                        rawName: "v-translate"
                                      }
                                    ]
                                  },
                                  [
                                    _vm._v(
                                      'Hiermit exportieren Sie die Seite "%{ currentElement.attributes.title }" als PDF-Datei.'
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "cw-element-export"
                                  },
                                  [
                                    _c(
                                      "label",
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.pdfExportChildren,
                                              expression: "pdfExportChildren"
                                            }
                                          ],
                                          attrs: {
                                            type: "checkbox"
                                          },
                                          domProps: {
                                            checked: Array.isArray(
                                              _vm.pdfExportChildren
                                            )
                                              ? _vm._i(
                                                  _vm.pdfExportChildren,
                                                  null
                                                ) > -1
                                              : _vm.pdfExportChildren
                                          },
                                          on: {
                                            change: function change($event) {
                                              var $$a = _vm.pdfExportChildren,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false

                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)

                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    (_vm.pdfExportChildren = $$a.concat(
                                                      [$$v]
                                                    ))
                                                } else {
                                                  $$i > -1 &&
                                                    (_vm.pdfExportChildren = $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      ))
                                                }
                                              } else {
                                                _vm.pdfExportChildren = $$c
                                              }
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("translate", [
                                          _vm._v("Unterseiten exportieren")
                                        ])
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        2009787905
                      )
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.showOerDialog
                  ? _c("studip-dialog", {
                      attrs: {
                        height: "600",
                        width: "600",
                        title: _vm.textOer.title,
                        confirmText: _vm.textOer.confirm,
                        confirmClass: "accept",
                        closeText: _vm.textOer.close,
                        closeClass: "cancel"
                      },
                      on: {
                        close: function close($event) {
                          return _vm.showElementOerDialog(false)
                        },
                        confirm: _vm.publishCurrentElement
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "dialogContent",
                            fn: function fn() {
                              return [
                                _c(
                                  "form",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !_vm.oerExportRunning,
                                        expression: "!oerExportRunning"
                                      }
                                    ],
                                    staticClass: "default",
                                    on: {
                                      submit: function submit($event) {
                                        $event.preventDefault()
                                      }
                                    }
                                  },
                                  [
                                    _c("fieldset", [
                                      _c(
                                        "legend",
                                        [
                                          _c("translate", [
                                            _vm._v("Grunddaten")
                                          ])
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("label", [
                                        _c(
                                          "p",
                                          [
                                            _c("translate", [
                                              _vm._v("Vorschaubild")
                                            ]),
                                            _vm._v(":")
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _vm.currentElement.relationships.image
                                          .data
                                          ? _c("img", {
                                              attrs: {
                                                src:
                                                  _vm.currentElement
                                                    .relationships.image.meta[
                                                    "download-url"
                                                  ],
                                                width: "400"
                                              }
                                            })
                                          : _vm._e()
                                      ]),
                                      _vm._v(" "),
                                      _c("label", [
                                        _c(
                                          "p",
                                          [
                                            _c("translate", [
                                              _vm._v("Beschreibung")
                                            ]),
                                            _vm._v(":")
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.currentElement.attributes
                                                .payload.description
                                            )
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        [
                                          _c("translate", [_vm._v("Niveau")]),
                                          _vm._v(
                                            ":\n                                "
                                          ),
                                          _c("p", [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  _vm.currentElement.attributes
                                                    .payload.difficulty_start
                                                ) +
                                                " -\n                                    " +
                                                _vm._s(
                                                  _vm.currentElement.attributes
                                                    .payload.difficulty_end
                                                ) +
                                                "\n                                "
                                            )
                                          ])
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        [
                                          _c("translate", [
                                            _vm._v("Lizenztyp")
                                          ]),
                                          _vm._v(
                                            ":\n                                "
                                          ),
                                          _c("p", [
                                            _vm._v(
                                              _vm._s(_vm.currentLicenseName)
                                            )
                                          ])
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        [
                                          _c("translate", [
                                            _vm._v(
                                              'Sie können diese Daten unter "Seiteneinstellungen" verändern.'
                                            )
                                          ])
                                        ],
                                        1
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("fieldset", [
                                      _c(
                                        "legend",
                                        [
                                          _c("translate", [
                                            _vm._v("Einstellungen")
                                          ])
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        [
                                          _c("translate", [
                                            _vm._v(
                                              "Unterseiten veröffentlichen"
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.oerChildren,
                                                expression: "oerChildren"
                                              }
                                            ],
                                            attrs: {
                                              type: "checkbox"
                                            },
                                            domProps: {
                                              checked: Array.isArray(
                                                _vm.oerChildren
                                              )
                                                ? _vm._i(
                                                    _vm.oerChildren,
                                                    null
                                                  ) > -1
                                                : _vm.oerChildren
                                            },
                                            on: {
                                              change: function change($event) {
                                                var $$a = _vm.oerChildren,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false

                                                if (Array.isArray($$a)) {
                                                  var $$v = null,
                                                    $$i = _vm._i($$a, $$v)

                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      (_vm.oerChildren = $$a.concat(
                                                        [$$v]
                                                      ))
                                                  } else {
                                                    $$i > -1 &&
                                                      (_vm.oerChildren = $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        ))
                                                  }
                                                } else {
                                                  _vm.oerChildren = $$c
                                                }
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c("courseware-companion-box", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.oerExportRunning,
                                      expression: "oerExportRunning"
                                    }
                                  ],
                                  attrs: {
                                    msgCompanion: _vm.$gettext(
                                      "Export läuft, bitte haben sie einen Moment Geduld..."
                                    ),
                                    mood: "pointing"
                                  }
                                })
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        4103327435
                      )
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.showSuggestOerDialog
                  ? _c("studip-dialog", {
                      attrs: {
                        height: "600",
                        width: "600",
                        title: _vm.textSuggestOer.title,
                        confirmText: _vm.textSuggestOer.confirm,
                        confirmClass: "accept",
                        closeText: _vm.textSuggestOer.close,
                        closeClass: "cancel"
                      },
                      on: {
                        close: function close($event) {
                          return _vm.updateShowSuggestOerDialog(false)
                        },
                        confirm: _vm.sendOerSuggestion
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "dialogContent",
                            fn: function fn() {
                              return [
                                _c(
                                  "p",
                                  {
                                    directives: [
                                      {
                                        name: "translate",
                                        rawName: "v-translate"
                                      }
                                    ]
                                  },
                                  [
                                    _vm._v(
                                      "Das folgende Courseware-Material wird %{ ownerName }\n                        zur Veröffentlichung im %{ oerTitle } vorgeschlagen:"
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "table",
                                  {
                                    staticClass: "cw-structural-element-info"
                                  },
                                  [
                                    _c("tr", [
                                      _c(
                                        "td",
                                        [
                                          _c("translate", [_vm._v("Titel")]),
                                          _vm._v(":")
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.structuralElement.attributes
                                              .title
                                          )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c(
                                        "td",
                                        [
                                          _c("translate", [
                                            _vm._v("Beschreibung")
                                          ]),
                                          _vm._v(":")
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.structuralElement.attributes
                                              .payload.description
                                          )
                                        )
                                      ])
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "form",
                                  {
                                    staticClass: "default",
                                    on: {
                                      submit: function submit($event) {
                                        $event.preventDefault()
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "label",
                                      [
                                        _c("translate", [
                                          _vm._v(
                                            "Ihr Vorschlag wird anonym versendet. Falls gewünscht, können Sie\n                                zusätzlich eine Nachricht verfassen:"
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("textarea", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.additionalText,
                                              expression: "additionalText"
                                            }
                                          ],
                                          staticClass:
                                            "cw-structural-element-description",
                                          domProps: {
                                            value: _vm.additionalText
                                          },
                                          on: {
                                            input: function input($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.additionalText =
                                                $event.target.value
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        2589733047
                      )
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.showDeleteDialog
                  ? _c("studip-dialog", {
                      attrs: {
                        title: _vm.textDelete.title,
                        question: _vm.textDelete.alert,
                        height: "180"
                      },
                      on: {
                        confirm: _vm.deleteCurrentElement,
                        close: _vm.closeDeleteDialog
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.showLinkDialog
                  ? _c("studip-dialog", {
                      staticClass: "cw-structural-element-dialog",
                      attrs: {
                        title: _vm.$gettext(
                          "Öffentlichen Link für Seite erzeugen"
                        ),
                        confirmText: _vm.$gettext("Erstellen"),
                        confirmClass: "accept",
                        closeText: _vm.$gettext("Schließen"),
                        closeClass: "cancel"
                      },
                      on: {
                        close: _vm.closeLinkDialog,
                        confirm: _vm.createElementLink
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "dialogContent",
                            fn: function fn() {
                              return [
                                _c(
                                  "form",
                                  {
                                    staticClass: "default",
                                    on: {
                                      submit: function submit($event) {
                                        $event.preventDefault()
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "label",
                                      [
                                        _c("translate", [_vm._v("Passwort")]),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.publicLink.password,
                                              expression: "publicLink.password"
                                            }
                                          ],
                                          attrs: {
                                            type: "password"
                                          },
                                          domProps: {
                                            value: _vm.publicLink.password
                                          },
                                          on: {
                                            input: function input($event) {
                                              if ($event.target.composing) {
                                                return
                                              }

                                              _vm.$set(
                                                _vm.publicLink,
                                                "password",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      [
                                        _c("translate", [
                                          _vm._v("Ablaufdatum")
                                        ]),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.publicLink["expire-date"],
                                              expression:
                                                "publicLink['expire-date']"
                                            }
                                          ],
                                          staticClass: "size-l",
                                          attrs: {
                                            type: "date"
                                          },
                                          domProps: {
                                            value: _vm.publicLink["expire-date"]
                                          },
                                          on: {
                                            input: function input($event) {
                                              if ($event.target.composing) {
                                                return
                                              }

                                              _vm.$set(
                                                _vm.publicLink,
                                                "expire-date",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        2152619175
                      )
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.showRemoveLockDialog
                  ? _c("studip-dialog", {
                      attrs: {
                        title: _vm.textRemoveLock.title,
                        question: _vm.textRemoveLock.alert,
                        height: "200",
                        width: "450"
                      },
                      on: {
                        confirm: _vm.executeRemoveLock,
                        close: function close($event) {
                          return _vm.showElementRemoveLockDialog(false)
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          : _c(
              "div",
              [
                _vm.currentElement !== ""
                  ? _c("courseware-companion-box", {
                      attrs: {
                        msgCompanion: _vm.textCompanionWrongContext,
                        mood: "sad"
                      }
                    })
                  : _vm._e()
              ],
              1
            )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }